export enum SocketEvents {
  // Connection
  CONNECT = "connect",
  DISCONNECT = "disconnect",
  RECONNECT = "reconnect",

  // User Status
  USER_ONLINE = "user-online",
  USER_OFFLINE = "user-offline",
  UPDATE_USER_STATUS = "user-status-update",

  // Call Initiation
  CALL_INITIATE = "call:initiate",
  CALL_INITIATED = "call:initiated",
  CALL_INCOMING = "call:incoming",
  CALL_INITIATE_ERROR = "call:initiate:error",

  // Call Acceptance
  CALL_ACCEPT = "call:accept",
  CALL_ACCEPTED = "call:accepted",
  CALL_ACCEPTED_BY_RECIPIENT = "call:accepted:by:recipient",
  CALL_ACCEPT_ERROR = "call:accept:error",

  // Call Rejection
  CALL_REJECT = "call:reject",
  CALL_REJECTED = "call:rejected",
  CALL_REJECTED_CONFIRMED = "call:rejected:confirmed",
  CALL_REJECTED_BY_RECIPIENT = "call:rejected:by:recipient",
  CALL_REJECT_ERROR = "call:reject:error",

  // Call Cancellation
  CALL_CANCEL = "call:cancel",
  CALL_CANCELLED = "call:cancelled",
  CALL_CANCELLED_BY_INITIATOR = "call:cancelled:by:initiator",
  CALL_CANCEL_ERROR = "call:cancel:error",

  // Call Connection
  CALL_CONNECTED = "call:connected",
  CALL_CONNECTED_CONFIRMED = "call:connected:confirmed",
  CALL_CONNECTED_ERROR = "call:connected:error",
  CALL_MEDIA_STARTED = "call:media:started",

  // Call Termination
  CALL_END = "call:end",
  CALL_ENDED = "call:ended",
  CALL_END_ERROR = "call:end:error",

  // Timeout/Missed
  CALL_MISSED = "call:missed",
  CALL_TIMEOUT = "call:timeout",

  // Admin Events
  ADMIN_UI_SYNC = "admin:ui:sync",
  ADMIN_ROUTING_UPDATE = "admin:routing:update",
  ADMIN_CALL_CREATED = "admin-call-created",
  ADMIN_CALL_ACCEPTED = "admin-call-accepted",
  ADMIN_CALL_ENDED = "admin-call-ended",
  ADMIN_CALL_CANCELLED = "admin-call-cancelled",
  ADMIN_CALL_REJECTED = "admin-call-rejected",
  ADMIN_CALL_MISSED = "admin-call-missed",
  ADMIN_CALL_JOINED = "admin:call:joined",

  // Admin Actions
  ADMIN_JOIN_CALL = "admin:join:call",
  ADMIN_JOINED_CALL = "admin:call:joined",
  ADMIN_JOIN_CALL_ERROR = "admin:join:call:error",
  ADMIN_LEAVE_CALL = "admin:leave:call",
  ADMIN_LEFT_CALL = "admin:call:left",
  ADMIN_LEAVE_CALL_ERROR = "admin:leave:call:error",

  // Call Recovery (merged)
  CALL_REJOIN = "call:rejoin",
  CALL_REJOIN_RESPONSE = "call:rejoin:response",
  CALL_REJOIN_AVAILABLE = "call:rejoin:available",
  CALL_REJOIN_ERROR = "call:rejoin:error",

  // LiveKit / Room Events
  PARTICIPANT_JOINED = "participant-joined",
  PARTICIPANT_LEFT = "participant-left",
  MEDIA_UPDATED = "media-updated",

  // Room signaling (if handled via socket)
  JOIN_ROOM = "join-room",
  LEAVE_ROOM = "leave-room",
}

export type SocketEvent = SocketEvents;

